module.exports = __webpack_public_path__ + "img/gateway4.cd263f1a.png";